import { getApplicableParts } from "@dana/Services/DanaCompatibleWithApplicationService";
import {
    createHandlerChainRunner,
    Handler
} from "@insite/client-framework/HandlerCreator";
import { HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { BaseModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

export interface GetCreditMemosParameter extends HasPagingParameters {
    creditMemoNumber?: string;
    primaryPONumber?: string;
    secondaryPoNumber?: string;
    partNumber?: string;
    creditMemoTotal?: string;
    fromDate?: string;
    poNumber?: string;
    toDate?: string;
    sortBy?: string;
    orderType?: string;
}

export interface ApplicationYearMakeModelFilter extends HasPagingParameters {
    year?: string;
    make?: string;
    model?: string;
    engine?: string;
    sortBy?: string;
    orderType?: string;
}
export interface CompatibleWithApplicationPartModel extends ApplicationYearMakeModelFilter, BaseModel {
    partNumber?: string;
    applicationNo?: string;
    location?: string;
    fitmentNotes?: string;
}
export interface PartCollectionModel extends BaseModel {
    productParts: CompatibleWithApplicationPartModel[] | null;
    pagination: PaginationModel

}

export interface CompatibleWithApplicationParameter extends ApplicationYearMakeModelFilter {
    partNumber?: string;
}
interface Props {
    apiParameter: CompatibleWithApplicationParameter;
    apiResult: PartCollectionModel;
}
type HandlerType = Handler<CompatibleWithApplicationParameter, Props>;


export const SetLoadingOn: HandlerType = props => {
    props.apiParameter = {
        partNumber: props.parameter.partNumber,
        year: props.parameter.year,
        make: props.parameter.make,
        model: props.parameter.model,
        engine: props.parameter.engine,
        page: props.parameter.page,
        pageSize: props.parameter.pageSize,
        sort: props.parameter.sort,
        sortBy: props.parameter.sortBy
    };

    props.dispatch?.({
        type: "CompatibleWithApplicationParts/StartLoading",
        isLoading: true,
    } as any);
}
export const GetCompatibleParts: HandlerType = async props => {
   
    props.apiResult = await getApplicableParts(props.apiParameter);
    props.dispatch?.({
        type: "CompatibleWithApplicationParts/LoadComplete",
        parts: props.apiResult.productParts,
        pagination: props.apiResult.pagination,
        filter: props.parameter
    } as any);
}
export const SetLoadingOff: HandlerType = props => {
    props.dispatch?.({
        type: "CompatibleWithApplication/EndLoading",
        isLoading: false,
    } as any);
}
export const chain = [
    SetLoadingOn,
    GetCompatibleParts,
    SetLoadingOff
];

const loadCompatibleWithApplicationParts = createHandlerChainRunner(chain, "CompatibleWithApplicationHandler");
export default loadCompatibleWithApplicationParts;
